import tinycolor from 'tinycolor2'

export const fade = (hex: string, alpha: number): string => tinycolor(hex).setAlpha(alpha).toRgbString()

export const darkenOrLighten = (hex: string, amount: number): string => {
	const color = tinycolor(hex)
	const changedColor = color.isDark() ? color.lighten(amount) : color.darken(amount)
	return changedColor.toString()
}

export const colorMix = (
	startColour: string,
	colourToMixIn: string,
	mixAmount: number,
	darkMixAmount: number | null = null,
): string => {
	const c1 = tinycolor(startColour)
	const c2 = tinycolor(colourToMixIn)
	let amount = mixAmount

	if (c1.isDark() && darkMixAmount) {
		amount = darkMixAmount
	}

	return tinycolor.mix(c1, c2, amount).toHexString()
}

export const isDark = (hex: string): boolean => tinycolor(hex).isDark()

export const mostLegibleOn = (background: string, candidates: string[]): string =>
	candidates.reduce((best, candidate) =>
		tinycolor.readability(candidate, background) > tinycolor.readability(best, background) ? candidate : best,
	)
